<template>
  <div class="privacyBox">
    <h3>祥瑞金业有限公司</h3>
    <div class="line"></div>
    <div>
        <h2>公司简介</h2>
        <p>祥瑞金业，全称香港祥瑞金业有限公司，英文名HONG KONG PROSPERITY BULLION LIMITED，中文简称祥瑞，英文Prosperity。成立于2013年，面向全球市场。是一家长期专业从事贵金属交易、实物买卖的企业，致力于为全球的投资客户提供多层次、多品种、多通道、多核心的金融体系化交易平台。祥瑞金业是香港金银业贸易场贵金属网上交易的专业营运商、经营伦敦金、伦敦银及人民币公斤条等贵金属业务。</p>
        <p>祥瑞业务涉及贵金属理财、黄金白银交易、实物买卖、贵金属产业投资等领域，在全球多地设有分部或分支机构，能为有需要的全球客户提供便捷的贵金属全方位服务。</p>
        <ul>
            <li><span class="red">公司名称</span>：祥瑞金业有限公司</li>
            <li><span class="red">外文名</span>：HONG KONG PROSPERITY BULLION LIMITED</li>
            <li><span class="red">简称</span>：祥瑞/Prosperity</li>
            <li><span class="red">所属行业</span>：贵金属</li>
            <li><span class="red">成立时间</span>：2013年4月12日</li>
            <li><span class="red">员工人数</span>：200人</li>
            <li><span class="red">总部地点</span>：中国·香港</li>
            <li><span class="red">经营范围</span>：黄金理财黄金买卖等</li>
            <li><span class="red">公司口号</span>：祥运瑞气金相伴，富贵乐享从容至</li>
            <li><span class="red">牌照编号</span>：087号</li>
        </ul>
        <h2>企业简介</h2>
        <p>祥瑞金业成立多年，从黄金电子交易单一业务开始发展，扩展到黄金、白银、钯金和铂金全品种，从贵金属的线上买卖交易到实物交易、贵金属理财、投资、人民币公斤条业务等全业务线拓展，成为一家专业综合性的贵金属企业，总部位于香港金融核心区。</p>
        <p>祥瑞拥有自主研发的交易系统、多核多备、复合交易、兼备通道交易的集群系统，同时独有的风控系统，完美配合交易系统，多个流动性配合使得交易方便快捷。独家开发了去中心化的网站、H5和App，为客户提供便捷的交易平台和工具。</p>
        <p>祥瑞汇集了大量从事多年金融、期货、证券和外汇及贵金属行业经验及专业的专家管理团队，长期为客户提供高质量的服务和咨询。客户在交易过程中，不仅可以提供公平、公开、透明、安全的交易环境，还能及时获取祥瑞专家团队最新的市场资讯和分析报告。</p>
        <h2>贵金属资质</h2>
        <p>香港祥瑞金业有限公司是金银业贸易场的AA类行员，行员编号：087，并拥有黄金及白银的交易和投资牌照，所有交易活动均受到金银业贸易场的认可和监管，同时受到香港法律监督和香港海关的监管。</p>
        <div class="imagegroup">
            <img src="../../static/aboutus/image1.png" alt="">
            <img src="../../static/aboutus/image2.png" alt="">
        </div>
        <h2>祥瑞交易系统特点</h2>
        <ul>
            <li>
                <b>(1)降低了交易门槛：</b>为了让更多的投资者能够参与到贵金属交易中来，香港祥瑞金业推出了多样化的黄金和白银产品，满足不同客户的需求。
            </li>
            <li>
                <b>(2)降低专业门槛：</b>祥瑞打造多年的研究实力和专家队伍，为祥瑞的客户提供了专业、容易理解、降低难度、多元化的投资教育视频和内容。提供各类投资研报，按照时间、品种和交易热点品种等分类。
            </li>
            <li>
                <b>(3)升级服务系统：</b>给投资者提供全方位的金融服务，24小时在线客服实时对话，技术部门24小时线上支持，热线及时响应回复。
            </li>
            <li>
                <b>(4)支付体系：</b>祥瑞金业采用多种方式保障客户的资金安全，以确保客户的资金从转账，交易，到取款的各个环节都安全无忧。祥瑞公司打造客户资金专门账户，独立与祥瑞自身的账户，以便独立运营用于客户的资金往来。
            </li>
        </ul>
        <h2>信息安全</h2>
        <p>祥瑞非常重视客户的数据信息安全，独家研发了基于自研、业内先进的安全技术；独家的数据运营和管理，将客户的所有数据信息存储在与外界隔绝的数据库中。所有内部人员都签署了严格的保密协议，不得向外界泄露任何信息，一经发现，将追究其法律责任。</p>
        <p>祥瑞也不会向任何第三方的机构或个人透露客户的信息数据。客户的个人数据和交易信息都享有最高级别的保护。同时祥瑞也建议客户本人保护好自己的信息数据。建议定期修改密码，不要对外透露信息数据。</p>
        <h2>公司优势</h2>
        <ul>
            <li>
                <b>(1)产品优势：</b>祥瑞的交易系统和风控及各类平台，采用国际流行的多语言多版本多迭代、结合人工智能AI，经过多年时间和多次风险事件的考验，打造出来的全新智能软件，独家运行交易利器，拥有超强的下单执行能力。可以24小时网上交易，随时掌握市场动态。
            </li>
            <li>
                <b>(2)信誉优势：</b>祥瑞持有金银业贸易场AA类牌照（行员编号087号）。祥瑞拥有稳定的平台系统及交易数据，为客户提供先进高效的交易和投资服务，公平可靠。
            </li>
            <li>
                <b>(3)资金优势：</b>祥瑞资金雄厚，从小白客户到全球大机构均可参与祥瑞平台交易；祥瑞利用资金优势可以交割大吨位实物黄金。客户可以通过网上银行汇款，分分钟到账，实时注资交易。可以24小时随时取款，到账迅捷。出入金顺畅，资金安全有保障，银行级别加密系统保护账号安全，用户可以随时查看资金变动的具体情况，及时掌控资金流向。
            </li>
            <li>
                <b>(4)服务优势：</b>祥瑞打造24小时在线客服，涵盖周末和假期全年无休，随时解答客户的投资疑问。每笔取款专人跟进，取款到账通知。祥瑞给客户投资交易，提供第一手金融信息，助客户掌握行情走势。香港祥瑞金业在APP和PC端均提供从小白、入门到高级的网上教学视频和专业分析师教学直播，简单易懂。
            </li>
            <li>
                <b>(5)直播间优势：</b>祥瑞组建了金融研究院，聘请专家团队和中外分析师，打造为客户从入门到高阶再到专家级交易的直播系统。有资深的分析师和专家担当直播，在线分析行情、解读全球热点新闻事件、追踪资金和经济金融变化的趋势，给投资者提供最具专业化的建议和意见析，帮助客户制定合适的投资策略。
            </li>
            <li>
                <b>(6)交易优势：</b>在祥瑞交易系统和平台上，客户可以24小时不间断的交易。交易系统具有随时建仓平仓，每一个操作决定实时执行。支持智能挂单，智能执行止损止盈，即使客户离线也能精准执行操作。实时交易，可以买升买跌，杠杆100倍，开户只需预存50美元，佣金手续费全免。
            </li>
        </ul>
        <h2>企业文化</h2>
        <ul>
            <li>
                <b>企业愿景：</b>成为全球贵金属交易领域的领导者、贵金属行业的佼佼者。为客户、员工、社会和股东创造价值，推动金融交易的创新和高质量的发展。
            </li>
            <li>
                <b>企业使命：</b>为客户提供高效、安全、公正的贵金属交易平台和优质的服务，为员工提供良好的发展和福利，为社会提供积极的贡献。
            </li>
            <li>
                <b>企业精神：</b>诚信、专业、创新、共赢。
            </li>
        </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "Privacy",
  created() {
    // 传参控制显示顶部和底部
    this.$emit("controlShow", false);
  },
};
</script>

<style lang="less" scoped>
.privacyBox {
   
  width: 1138px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  padding: 50px 0 110px;
  .imagegroup{
    img{
        margin-right: 50px;
    }
  }
  p{
     text-indent: 2rem;
     line-height: 25px;
  }
  ul{
    li{
        .red{
            color: red;
        }
        line-height: 30px;
    }
  }
  h3 {
    font-size: 24px;
  }
  .line {
    width: 100%;
    height: 1px;
    background-color: #eaeaea;
    margin: 40px auto 60px;
  }
  .ulOne {
    li {
      line-height: 25px;
      letter-spacing: 1px;
      margin-bottom: 40px;
      color: #6d6d6d;
    }
  }
  .ulTwo {
    width: 100%;
    li {
      line-height: 25px;
      letter-spacing: 1px;
      color: #6d6d6d;
    }
  }
  h4 {
    width: 100%;
    float: left;
    margin: 50px 0 0;
    font-size: 20px;
  }
  h5 {
    font-size: 16px;
  }
  .ulThree {
    line-height: 25px;
    letter-spacing: 1px;
    color: #6d6d6d;
    span {
      // color: #fe0100;
    }
  }
  .ulFour {
    width: 100%;
    margin-top: 40px;
    p {
      line-height: 25px;
      letter-spacing: 1px;
      color: #6d6d6d;
      margin: 0;
    }
    li {
      padding-left: 20px;
      line-height: 25px;
      letter-spacing: 1px;
      color: #6d6d6d;
    }
  }
}
</style>
